import React, { useState, useEffect } from "react";

const RangeInputDualSingleField = ({
  name,
  formValue,
  min = 100000,
  max = 800000,
  step = 5000,
  setValue, // <- pass setValue from useForm
}) => {
  const parseFormValue = (value) => {
    if (!value) return [min, max];
    const parts = value.split("-").map(Number);
    if (parts.length !== 2 || parts.some(isNaN)) return [min, max];
    return parts;
  };

  const [minVal, setMinVal] = useState(parseFormValue(formValue)[0]);
  const [maxVal, setMaxVal] = useState(parseFormValue(formValue)[1]);

  // Update state if formValue changes externally
  useEffect(() => {
    if (formValue) {
      const [fMin, fMax] = parseFormValue(formValue);
      setMinVal(fMin);
      setMaxVal(fMax);
    }
  }, [formValue]);

  // Update form state whenever minVal or maxVal changes
  useEffect(() => {
    setValue(name, `${minVal}-${maxVal}`, { shouldValidate: true });
  }, [minVal, maxVal, name, setValue]);

  const handleMinChange = (val) => {
    const num = Math.min(Number(val), maxVal - step);
    if (!isNaN(num) && num >= min) setMinVal(num);
  };

  const handleMaxChange = (val) => {
    const num = Math.max(Number(val), minVal + step);
    if (!isNaN(num) && num <= max) setMaxVal(num);
  };

  return (
    <div className="w-full space-y-2">
      <div className="flex space-x-2">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={minVal}
          onChange={(e) => handleMinChange(e.target.value)}
          className="w-full accent-blue-600 cursor-pointer"
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={maxVal}
          onChange={(e) => handleMaxChange(e.target.value)}
          className="w-full accent-blue-600 cursor-pointer"
        />
      </div>

      <div className="flex space-x-4 mt-1">
        <div>
          <label className="text-sm font-medium">Min:</label>
          <input
            type="number"
            value={minVal}
            onChange={(e) => handleMinChange(e.target.value)}
            min={min}
            max={maxVal - step}
            step={step}
            className="border border-gray-300 rounded px-2 py-1 w-32 text-sm"
          />
        </div>
        <div>
          <label className="text-sm font-medium">Max:</label>
          <input
            type="number"
            value={maxVal}
            onChange={(e) => handleMaxChange(e.target.value)}
            min={minVal + step}
            max={max}
            step={step}
            className="border border-gray-300 rounded px-2 py-1 w-32 text-sm"
          />
        </div>
      </div>

      <div className="text-sm text-gray-600">
        Selected Range: {(minVal / 100000).toFixed(1)} – {(maxVal / 100000).toFixed(1)} LPA
      </div>
    </div>
  );
};

export default RangeInputDualSingleField;
